import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { NewBookingView } from "../../firestore/Types/NewBookingSchema";
import { Roles } from "../../firestore/Types/PermissionSchema";
import { faSchoolCircleExclamation } from "@fortawesome/free-solid-svg-icons";

export function CalendarNewRequest({ newBooking, onClick }: { newBooking: NewBookingView, onClick?: (booking: NewBookingView) => void }) {
    const { permission } = useAuth();
    //const calendarBaseSetting = { showDate: true, showTopGutter: true } as CalendarBaseSetting;
    const dates = [] as number[];
    const subjectNames = useUtility().subjects;

    function getCurrentWeekDates() {
        const currentDate = new Date();
        const firstDayOfWeek = currentDate.getDate() - currentDate.getDay() + 1; // Assuming week starts on Monday


        for (let i = 0; i < 7; i++) {
            const date = new Date(currentDate.setDate(firstDayOfWeek + i));
            dates.push(date.getDate());
        }

    }
    getCurrentWeekDates();

    const getSubjectName = (subjectID: string) => {
        // Get subject name from subject ID
        for (const subject of subjectNames) {
            if (subject.Id === subjectID) {
                return subject.SubjectName;
            }
        }
        return "";
    }

    const invokeOnClick = () => {
        if (onClick) {
            onClick(newBooking);
        }
    }

    return (
        <>
            {
                <div onClick={invokeOnClick}>
                    <div className="cal-new-request grow flex flex-col m-1 p-2">
                        <div className="flex flex-row mt-2">
                            <div className="cal-time grow">
                                { permission.Role !== Roles.User ? <div className="cal-description mt-1">Student - {newBooking.StudentName}</div> : <></> }
                                {permission.Role !== Roles.Tutor ? <div className="cal-description mt-1">Tutor - {newBooking.TutorName}</div> : <></>}
                            </div>
                            <div><FontAwesomeIcon icon={faSchoolCircleExclamation} title="Session" fontSize="20px" /></div>
                        </div>
                     
                        <div className="cal-description mt-3">{newBooking.IsRecurring ? "Weekly" : "One Time"}</div>
                        <div className="cal-description mt-3">{getSubjectName(newBooking.SubjectId)}</div>
                    </div>
                </div>
            }
        </>
    );
}